<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img [src]="logoUrl" alt="" width="30" />
          </span>
          <span class="logo-lg">
            <img [src]="logoUrl" alt="" height="42" />
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img [src]="logoUrl" alt="" width="30" />
          </span>
          <span class="logo-lg">
            <img [src]="logoUrl" alt="" height="42" />
          </span>
        </a>
      </div>

      <button
        type="button"
        class="btn btn-sm px-3 font-size-16 header-item"
        id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)"
      >
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <!-- App Search-->
      <form class="app-search d-none d-lg-block" (ngSubmit)="onSearch($event)">
        <div class="position-relative">
          <input
            type="text"
            class="form-control"
            [placeholder]="'topbar.searchPlaceholder' | translate"
            [(ngModel)]="searchQuery"
            name="search"
            (input)="onSearchInput($event)"
            (keyup.escape)="clearSearch()"
          />
          <button class="btn btn-primary" type="submit">
            <i class="bx bx-search-alt align-middle"></i>
          </button>
        </div>
      </form>
    </div>

    <div class="d-flex">
      <div class="dropdown d-inline-block d-lg-none ms-2" ngbDropdown>
        <button
          type="button"
          class="btn header-item"
          id="page-header-search-dropdown"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          ngbDropdownToggle
        >
          <i-feather name="search" class="icon-lg"></i-feather>
        </button>
        <div
          class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
          aria-labelledby="page-header-search-dropdown"
          ngbDropdownMenu
        >
          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="'topbar.searchPlaceholder' | translate"
                  aria-label="Search Result"
                />

                <button class="btn btn-primary" type="submit">
                  <i class="mdi mdi-magnify"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div
        *ngIf="currentFolderName"
        class="current-folder-chip d-none d-lg-inline-flex"
        [title]="currentFolderName"
      >
        <i class="bx bx-folder current-folder-chip__icon" aria-hidden="true"></i>
        <span class="current-folder-chip__name">{{ currentFolderName }}</span>
      </div>

      <div class="dropdown d-none d-sm-inline-block" ngbDropdown>
        <button
          type="button"
          class="btn header-item"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          ngbDropdownToggle
        >
          <span class="align-middle d-none d-md-inline-block">{{ context?.currentFirm?.name }}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block ms-1"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end firm-switcher-menu" ngbDropdownMenu>

          <div class="px-3 pt-3 pb-2">
            <p class="text-muted fw-semibold small mb-0 text-uppercase" style="letter-spacing: .05em">
              {{ "topbar.selectFirm" | translate }}
            </p>
          </div>

          <div class="firm-switcher-header d-flex align-items-center px-3 pb-1">
            <span class="flex-grow-1"></span>
            <span class="firm-switcher-col-label text-muted" [title]="'topbar.firm.labelFirm' | translate">
              <i class="mdi mdi-domain"></i>
            </span>
            <span class="firm-switcher-col-label text-muted" [title]="'topbar.firm.labelProfile' | translate">
              <i class="mdi mdi-account"></i>
            </span>
          </div>

          <div class="dropdown-divider mt-0"></div>

          @if (context.firms) { @for (firm of context.firms; track $index) {
          <a
            href="javascript:void(0);"
            class="dropdown-item firm-switcher-item d-flex align-items-center px-3 py-2"
            (click)="switchFirm(firm)"
            [ngClass]="{ active: context?.currentFirm?.id === firm.id }"
          >
            <i class="mdi me-2 firm-switcher-check"
              [ngClass]="context?.currentFirm?.id === firm.id ? 'mdi-check-circle text-success' : 'mdi-circle-outline text-muted'"
            ></i>
            <span class="flex-grow-1 firm-switcher-name">{{ firm.name }}</span>
            <span class="firm-switcher-col-label">
              <i class="mdi mdi-circle"
                [ngClass]="firm.firmIsActive ? 'text-success' : 'text-danger'"
                [title]="(firm.firmIsActive ? 'topbar.firm.active' : 'topbar.firm.inactive') | translate"
              ></i>
            </span>
            <span class="firm-switcher-col-label">
              <i class="mdi mdi-circle"
                [ngClass]="firm.isEnabled ? 'text-success' : 'text-danger'"
                [title]="(firm.isEnabled ? 'topbar.firm.enabled' : 'topbar.firm.disabled') | translate"
              ></i>
            </span>
          </a>
          } }

          <div class="dropdown-divider"></div>
          <a
            href="javascript:void(0);"
            class="dropdown-item d-flex align-items-center px-3 py-2 text-success fw-medium"
            (click)="addNewFirmModal()"
          >
            <i class="mdi mdi-plus-circle-outline me-2"></i>
            <span>{{ "topbar.addNewFirm" | translate }}</span>
          </a>
        </div>
      </div>

      <div class="dropdown d-none" ngbDropdown>
        <button
          type="button"
          class="btn header-item"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          ngbDropdownToggle
        >
          <!-- Drapeau masqué -->
<span style="display:none">
@if(flagvalue === undefined){
<img src="{{ valueset }}" alt="Header Language" height="16" />} @else {
<img src="{{ flagvalue }}" alt="Header Language" height="16" />
}
</span>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          @for (item of listLang; track $index) {
          <a
            href="javascript:void(0);"
            class="dropdown-item notify-item"
            (click)="setLanguage(item.text, item.lang, item.flag)"
            [ngClass]="{ active: cookieValue === item.lang }"
          >
            <img
              src="{{ item.flag }}"
              alt="user-image"
              class="me-1"
              height="12"
            />
            <span class="align-middle">{{ item.text }}</span>
          </a>
          }
        </div>
      </div>

      <div class="dropdown d-inline-block" ngbDropdown>
        <button
          type="button"
          class="btn header-item"
          id="page-header-user-dropdown"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          ngbDropdownToggle
        >
          <span>{{ userFullName }}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
          <a class="dropdown-item" (click)="editProfileModal()"
            ><i class="mdi mdi-face-man font-size-16 align-middle me-1"></i>
            {{ "topbar.profileName" | translate }}</a
          >
          <a class="dropdown-item" routerLink="/notification-preferences"
            ><i class="mdi mdi-bell-cog-outline font-size-16 align-middle me-1"></i>
            {{ "topbar.notificationPreferences" | translate }}</a
          >
          <div class="dropdown-divider"></div>
          <a
            class="dropdown-item"
            href="javascript: void(0);"
            (click)="logout()"
            ><i
              class="mdi mdi-logout text-muted font-size-16 align-middle me-1"
            ></i>
            <span class="align-middle" key="t-logout">{{
              "topbar.logout" | translate
            }}</span></a
          >
        </div>
      </div>
    </div>
  </div>
</header>
